import { defaultTo, map, orderBy } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  SalesItemOptionModel,
  SalesItemPriceRuleOrganizationModel,
  SalesItemPriceRuleStateModel,
  SalesItemPriceRuleBrandModel,
  BusinessLineModel,
} from '@common/models';
import { BusinessLineEnum } from '@common/models/Enums';

export interface ISalesItemPriceRuleModel extends IModel {
  salesItemPriceRuleId: number;
  salesItemId: number;
  salesItemOptionId: number | undefined;
  priority: number;
  isBlocking: boolean;
  startDate: string;
  endDate: string;
  price: number;
  packageAddOnPrice: number | undefined;
  dispensingFee: number | undefined;
  businessLineId: number;
  salesItemOption: SalesItemOptionModel;
  organizations: SalesItemPriceRuleOrganizationModel[];
  states: SalesItemPriceRuleStateModel[];
  brands: SalesItemPriceRuleBrandModel[];
  businessLine: BusinessLineModel;
}

export class SalesItemPriceRuleModel
  extends Model
  implements ModelRecord<ISalesItemPriceRuleModel>
{
  salesItemPriceRuleId: number;
  salesItemId: number;
  salesItemOptionId: number | undefined;
  priority: number;
  isBlocking: boolean;
  startDate: string;
  endDate: string;
  price: number;
  packageAddOnPrice: number | undefined;
  dispensingFee: number | undefined;
  businessLineId: number;
  salesItemOption: SalesItemOptionModel;
  organizations: SalesItemPriceRuleOrganizationModel[] = [];
  states: SalesItemPriceRuleStateModel[] = [];
  brands: SalesItemPriceRuleBrandModel[] = [];
  businessLine: BusinessLineModel;
  constructor(params?: Partial<ISalesItemPriceRuleModel>) {
    super(params);
    this.salesItemPriceRuleId = defaultTo(params?.salesItemPriceRuleId, 0);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesItemOptionId = defaultTo(params?.salesItemOptionId, undefined);
    this.priority = defaultTo(params?.priority, 0);
    this.isBlocking = defaultTo(params?.isBlocking, false);
    this.startDate = defaultTo(params?.startDate, '');
    this.endDate = defaultTo(params?.endDate, '');
    this.price = defaultTo(params?.price, 0);
    this.packageAddOnPrice = defaultTo(params?.packageAddOnPrice, undefined);
    this.dispensingFee = defaultTo(params?.dispensingFee, undefined);
    this.businessLineId = defaultTo(
      params?.businessLineId,
      BusinessLineEnum.Clinic,
    );
    this.salesItemOption = params?.salesItemOption
      ? new SalesItemOptionModel(params.salesItemOption)
      : new SalesItemOptionModel();
    map(
      orderBy(params?.organizations, (o) => o.organization?.name),
      (org) => {
        this.organizations.push(new SalesItemPriceRuleOrganizationModel(org));
      },
    );
    map(
      orderBy(params?.states, (o) => o.state?.name),
      (st) => {
        this.states.push(new SalesItemPriceRuleStateModel(st));
      },
    );
    map(
      orderBy(params?.brands, (o) => o.brand?.name),
      (br) => {
        this.brands.push(new SalesItemPriceRuleBrandModel(br));
      },
    );
    this.businessLine = params?.businessLine
      ? new BusinessLineModel(params.businessLine)
      : new BusinessLineModel();
  }
}
